// extracted by mini-css-extract-plugin
export default {"subtitle":"index_subtitle__qHUB+","label":"index_label__3kNhO","icon":"index_icon__F5-BV"};